import React, {useEffect, useState} from "react";
import { useTranslation } from 'react-i18next';
import { ScrollRestoration } from "react-router-dom";
import SEO from "components/SEO/SEO";

//CSS
import styles from  "./teidebynight.module.less";

const ExperienceTeideByNight = () => {

  const [t,i18n] = useTranslation("pages");
  const [actualImg, setActualImg] = useState(0);
  const images =[
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/teide-by-night/slide/1.jpg",
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/teide-by-night/slide/2.jpg",
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/teide-by-night/slide/3.jpg",
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/teide-by-night/slide/4.jpg",
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/teide-by-night/slide/5.jpg",
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/teide-by-night/slide/6.jpg",
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/teide-by-night/slide/7.jpg",
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/teide-by-night/slide/8.jpg"
  ]

  function handleChangeImg(direcction){
    if (direcction === "right"){
      if (actualImg < images.length-1) setActualImg(actualImg+1);
      else setActualImg(0);
    }else if (direcction === "left"){
      if (actualImg > 0) setActualImg(actualImg-1);
      else setActualImg(images.length-1);
    }
  }

  useEffect(()=>{
    const interval = setInterval(() => {
      handleChangeImg('right');
    }, 5000);
    return () => clearInterval(interval);
  },[actualImg])

  let imgsHTML=null;

  if(Array.isArray(images) && images.length){
    imgsHTML = images.map((img,index)=>{
      const imgid="img-"+index;
      const show = actualImg==index ? styles.slideImg + ' ' + styles.fadeIn :  styles.slideImg + ' ' + styles.fadeOut;
      return (
        <div key={index} className={show} id={imgid}>
          <img key={index} src={img} alt={"Slide " + index}/>
        </div>
      );
    });
  }

  return(
    <>
      <SEO title={t('experiences.teidebynight.SEOTitulo')} description={t('experiences.teidebynight.SEODescipcion')} name='Viajes Teide' type='experience' />

      <div className={styles.teidebynight}>

          <div className={styles.fotoIndexContent}>
              <img src={process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/teide-by-night/foto-index_" + i18n.language + ".jpg"} />
          </div>

          <div className={styles.introText}>
            <div className={styles.title}>{t('experiences.teidebynight.Teide bajo las estrellas')}</div>
            <div className={styles.text}>
              {t('experiences.teidebynight.El cielo del Parque Nacional de El Teide es considerado uno de los mejores lugares de observación de estrellas del mundo. Su escasa contaminación lumínica, altura, localización y clima, lo hacen un lugar especial')}
            </div>
          </div>

          <div className={styles.slide}>
            <div className={styles.slideContent}>{imgsHTML}</div>
            <div className={styles.imgsButtonsLeft} onClick={() => handleChangeImg("left")}></div>
            <div className={styles.imgsButtonsRight} onClick={() => handleChangeImg("right")}></div>
          </div>

          <div className={styles.infoText}>
            <div className={styles.title}>{t('experiences.teidebynight.Lo más interesante de Teide bajo las estrellas')}</div>
            <div className={styles.cols}>

              <div className={styles.col}><img src={process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/teide-by-night/interesante1.jpg"} /></div>

              <div className={styles.col}>
                <div className={styles.title}>{t('experiences.teidebynight.El cielo estrellado de el Teide')}</div>
                <div className={styles.text}>
                  <p>{t('experiences.teidebynight.El Parque Nacional del Teide es ideal para disfrutar de la visión del imponente cielo nocturno y la vía láctea. Allí se pueden observar  cosas tan increíbles como los anillos de Saturno, los cráteres de la Luna o infinitas galaxias y nebulosas. El Teide y las Cumbres de Tenerife obtuvieron en el 2014 el certificado “Starlight”, lo que los acredita como lugar privilegiado a nivel internacional para la observación de estrellas y ser el primer Patrimonio de la Humanidad con dicha acreditración')}.</p>
                  <p>{t('experiences.teidebynight.El cielo de Canarias reúne unas cualidades unicas que hacen que sea un lugar espectacular, como su clima estable, latitud que es cercana a trópico y la escaza contaminación lumínica. Por todo estas cualidades en 1964 se elige como lugar para observar el universos. Actualmente es uno de los 3 mejores telescopios del mundo junto con los de Chile y Hawaii, se sitúa a unos 2.400 metros de altura y en el trabajan científicos de todo el mundo')}.</p>
                  <p>{t('experiences.teidebynight.Pero antes de ser Izaña, existió otro lugar donde observar las estrellas. En las montañas que se encuentran en las cañadas del tedie, está Guajara, que con sus 2.717 metros es la más alta de todas. En ese lugar, en 1856 un astrónomo escocés llamado Charles Piazzi Smyth, considerado como el padre de las astronomía moderna, observó las estrellas, la luna e incluso los anillos de Saturno. El científico instaló allí el primer observatorio de Canarias y constato junto con otros investigadores que Canarias era un lugar privilegiado para la observación del universo')}.</p>
                </div>
              </div>

              <div className={styles.col}>
                <div className={styles.title}>{t('Saber más del Parque nacional de Las Cañadas del Teide')}</div>
                <div className={styles.text}>
                  <p>{t('experiences.teidebynight.Esta se sitúa en la parte más alta fe Tenerife y de España. En 1954 fue declarado como parque nacional comvirtiendose en el más antiguo de canarias y el tercero de España. En 2007 pasó a ser patrimonio de la Humanidad por la Unesco, y se encuentra en el listado de los 12 tesoros de España. Dentro del parque se encuentra El Tedie, que con sus 3.718 metros es la montaña más alta de España. El parque nacional es unos de los parques con más visitas anuales de España y de Europa y actualmente se encuentra en la posición novena del mundo')}.</p>
                  <p>{t('experiences.teidebynight.El parque tiene una rica fauna y flora. En el se pueden encontrar unas 168 especies diferentes, de ellas 58 son endémicas de canarias y tres de ellas se encuentran en peligro de extinción. De todas ellas destacar por su belleza y valor el tajinaste rojo, la jara de Las Cañadas, el rosal del guanche, la hierba pajonera, la retama del Teide y la violeta del Teide')}.</p>
                  <p>{t('experiences.teidebynight.Este lugar no solo tiene un alto valor astronomico, paisajístico o de fauna y flora. Para el aborigen canario, este lugar tenía un alto valor espiritual, al Tedie lo llamaban Echeyde “morada del maligno” y durante los periodos estivales Las cañadas lo usaban como lugar de pastoreo. Por todo esto, son numerosos los yacimientos aborígenes repartidos por todo el parque, dandole un valor mayor a la zona')}.</p>
                </div>
              </div>

              <div className={styles.col}><img src={process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/teide-by-night/interesante2.jpg"} /></div>

              <div className={styles.col}><img src={process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/teide-by-night/interesante3.jpg"} /></div>

              <div className={styles.col}>
                <div className={styles.title}>{t('experiences.teidebynight.Bodegas Reverón')}</div>
                <div className={styles.text}>
                  <p>{t('experiences.teidebynight.Esta bodega se situada en el municipio de Vilaflor de Chasna a unos 1.100 metros de altura, el lugar donde se encuentra el caserío tiene un peculiar nombre, Los Quemados. Se le dio este nombre a la zona porque en el siglo XVI sufrió un fuerte fuego, dejando carbonizado el pinar que allí se encontraba')}.</p>
                  <p>{t('experiences.teidebynight.El caserío fue adquirido y fue fundada en 1947 por Eugenio Reverón. Actualmente se trabajan unas 17 hectarias de terreno para el cultivo ecológico de la viña. Parte de la plantación se sitúa a más de 1.300 metros de altura, que junto con una correcta gestión del suelo, al que solo se aporta materia orgánica de origen biológico, un exhaustivo control del cultivo y una cuidada selección de la materia prima dan resultado unos vinos exclusivos de gran carácter y personalidad')}.</p>
                  <p>{t('experiences.teidebynight.Las variedades que utilizamos para la elaboración de nuestros vinos, están perfectamente adaptadas a la climatología, altura y necesidades del cultivo ecológico , siendo las más habituales la Listán Blanco para blancos secos y blancos afrutados y la Listán Negro, Tempranillo, Castellana, Cabernet Sauvignon… para los tintos')}.</p>
                  <p>{t('experiences.teidebynight.La bodega se construyo sobre la ya antigua bodega, siendo remodelada en su interior pero, sin perder la estética del edificio y del conjunto histórico. De esta manera se integran bajo un mismo edificio la tradición de la antigua elaboración y la modernidad de las nuevas instalaciones con los últimos adelantos técnicos')}.</p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.video}>
            <iframe src="https://player.vimeo.com/video/295708639?color=009933&title=0&byline=0&portrait=0" frameBorder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>
            <script src="https://player.vimeo.com/api/player.js"></script>
          </div>

          <div className={styles.tips}>
            <div className={styles.tip}>
              <img src={process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/teide-by-night/1-tip.png"} />
              <div className={styles.text}>{t('experiences.teidebynight.La Gomera es una de las islas del archipiélago que mejor ha conservado tradiciones de los habitantes prehispánicos, como las loceras de barro')}</div>
            </div>
            <div className={styles.tip}>
              <img src={process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/teide-by-night/2-tip.png"} />
              <div className={styles.text}>{t('experiences.teidebynight.Tienes una fiesta lustral, Bajada de la Virgen de Guadalupe. La sacan de su ermita y durante 2 meses está dando vueltas por la isla')}</div>
            </div>
            <div className={styles.tip}>
              <img src={process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/teide-by-night/3-tip.png"} />
              <div className={styles.text}>{t('experiences.teidebynight.Hasta los años 60, la economía dependía de la agricultura y ganadería. Hoy en día más del 80% viven del turismo')}</div>
            </div>
          </div>

      </div>
      <ScrollRestoration />
    </>
  );
}

export default ExperienceTeideByNight;